import {Button} from "antd";

const EnvAlert = () => {
    if(process.env.REACT_APP_ENV === "production") return null;

    return (
        <Button danger >DEV: {process.env.REACT_APP_API_URL}</Button>
    )
}
export default EnvAlert